import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {StatesService} from '../state/states.service';
import {LocationDataProcessMeasure} from '../../classes/offset/LocationDataProcessMeasure';
import {Observable} from 'rxjs';
import {GraphicComponentView} from '../../classes/graphic-component-view/graphic-component-view';
import {ProjectExportCsvComponent} from '../../../routed/project/project-export-csv/project-export-csv.component';
import {MatDialog} from '@angular/material/dialog';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ProjectMeasureService {

  private indexChartColor: number = 0;
  private indexChartGrayScale: number = 0;

  constructor(private http: HttpClient,
              private statesService: StatesService,
              private matDialog: MatDialog) {
  }

  getSettingsGraphicalView(projectId) {
    return this.http.get(`settings/graphical-view/` + projectId.toString());
  }

  getGraphicalComponentView(viewId: number) {
    return this.http.get(`setting/` + viewId.toString());
  }

  getMeasureEventDyn(start: string, end: string, location: number) {
    return this.http.get(`measures/event-dyn?dateStart=` + start + `&dateEnd=` + end + `&location=` + location);
  }

  postGraphicalComponentView(graphicComponentView: GraphicComponentView) {
    return this.http.post(`setting/graphical-view`, graphicComponentView);
  }

  putGraphicalComponentView(viewId: number, graphicComponentView: GraphicComponentView) {
    return this.http.put(`setting/graphical-view/` + viewId.toString(), graphicComponentView);
  }

  deleteGraphicalComponentView(viewId: number) {
    return this.http.delete(`setting/graphical-view/` + viewId.toString());
  }

  /**
   *
   * @param start
   * @param end
   * @param location
   * @param dynamicEvent
   * @param showOffset
   * @param underSampling
   * @param showSms
   * @param forceDyn
   */
  getMeasureStatic(start: string, end: string, location: number[], dynamicEvent: number, showOffset: number, underSampling: number, showSms: number, forceDyn: number = 0, timeOffset: number = 0) {
    let locations: string = '';
    let i = 0;
    location.forEach((l) => {
      i++;
      locations += l;
      locations += i < location.length ? ',' : '';

    });
    return this.http.get(
      `measures/safe/static?dateStart=` + start
      + `&dateEnd=` + end
      + `&location=` + locations
      + `&dynamicEvent=` + dynamicEvent
      + `&underSampling=` + underSampling
      + `&showOffset=` + showOffset
      + `&fromsms=` + showSms
      + `&forceDyn=` + forceDyn
      + `&timeOffset=` + timeOffset);
  }

  /**
   *
   * @param start
   * @param location
   * @param eventMaster
   * @param showOffset
   * @param underSampling
   * @param timeOffset
   */
  getMeasureDynamic(start: string, location: number[], eventMaster: number, showOffset: number, underSampling: number, timeOffset: number = 0) {
    let locations: string = '';
    let i = 0;
    location.forEach((l) => {
      i++;
      locations += l;
      locations += i < location.length ? ',' : '';

    });
    return this.http.get(
      `measures/safe/dynamic?dateStart=` + start
      + `&location=` + locations
      + `&eventMaster=` + eventMaster
      + `&underSampling=` + underSampling
      + `&showOffset=` + showOffset
      + `&timeOffset=` + timeOffset);

  }

  /**
   *
   * @param start
   * @param end
   * @param location
   * @param underSampling
   * @param timeOffset
   */
  getMeasureThermalCorrection(start: string, end: string, location: number[], underSampling: number, timeOffset: number = 0) {
    let locations: string = '';
    let i = 0;
    location.forEach((l) => {
      i++;
      locations += l;
      locations += i < location.length ? ',' : '';

    });
    return this.http.get(
      `measures/safe/thermal-correction?dateStart=` + start
      + `&dateEnd=` + end
      + `&location=` + locations
      + `&underSampling=` + underSampling
      + `&timeOffset=` + timeOffset);
  }

  getLocationDataProcessMeasure(idLocation: number, type: string) {
    return this.http.get(`data-processing-measure?location=` + idLocation + `&type=` + type);
  }

  postLocationDataProcessMeasure(dataProcessMeasure: LocationDataProcessMeasure) {
    return this.http.post(`data-processing-measure`, dataProcessMeasure);
  }

  patchLocationDataProcessMeasure(idDataProcessMeasure: number, offset: LocationDataProcessMeasure) {
    return this.http.patch(`data-processing-measure/` + idDataProcessMeasure, offset);
  }

  deleteLocationDataProcessMeasure(idDataProcessMeasure: any) {
    return this.http.delete(`data-processing-measure/` + idDataProcessMeasure);
  }

  public formatDateToString(time, date) {
    // Add '0' before number in case number has only one digit
    const formatTime = (value: number) => value < 10 ? '0' + value.toString() : value;
    const momentDate = moment(date).utc(false);
    // tslint:disable-next-line:max-line-length
    const string = `${formatTime(momentDate.year())}-${formatTime(momentDate.month() + 1)}-${formatTime(momentDate.date())}T${formatTime(time.hour)}:${formatTime(time.minute)}:${formatTime(time.second)}`;

    return string;
  }

  public formatDateToDisplay(date: string | number) {
    return moment(date).utc().format('YYYY-MM-DD HH:mm:ss');
  }

  public initDatePicker(date?) {
    const dateObject = date ? new Date(date) : new Date();
    return dateObject;
  }

  public initTimePicker(date?) {
    const dateObject = date ? new Date(date) : new Date();
    const timePicker = {
      hour: dateObject.getUTCHours(),
      minute: dateObject.getUTCMinutes(),
      second: dateObject.getUTCSeconds(),
    };

    return timePicker;
  }

  openExportCsvInterface(project) {
    const data = {
      idProject: project.id,
      start_date: project.start_date,
      end_date: project.end_date
    };
    this.matDialog.open(ProjectExportCsvComponent, {
      height: '90%',
      width: '95%',
      data
    });
  }
}
